import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label", "aria-hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["pkg-icon", [{ 'pkg-icon-colored': _ctx.colored }, _ctx.extraClass]]),
    style: _normalizeStyle(_ctx.colored ? { color: _ctx.visual.colorVar } : undefined),
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    role: "img",
    "aria-label": _ctx.label || undefined,
    "aria-hidden": _ctx.label ? undefined : 'true',
    focusable: "false"
  }, [
    (_ctx.visualId === 'gtr-go')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("circle", {
            cx: "12",
            cy: "12",
            r: "8.6"
          }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("path", { d: "m15.4 8.6-2 5.4-5.4 2 2-5.4 5.4-2Z" }, null, -1))
        ], 64))
      : (_ctx.visualId === 'gtr-fly')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[2] || (_cache[2] = _createElementVNode("path", { d: "M12 2.6c2.9 2.4 4.4 5.7 4.4 9.4 0 1.9-.3 3.6-1 5H8.6c-.7-1.4-1-3.1-1-5 0-3.7 1.5-7 4.4-9.4Z" }, null, -1)),
            _cache[3] || (_cache[3] = _createElementVNode("circle", {
              cx: "12",
              cy: "10",
              r: "1.9"
            }, null, -1)),
            _cache[4] || (_cache[4] = _createElementVNode("path", { d: "M7.7 12.6 4.6 15.1v3.3l3.1-1.7M16.3 12.6l3.1 2.5v3.3l-3.1-1.7" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("path", { d: "M10.1 19.4c.5 1.3 1.1 2 1.9 2s1.4-.7 1.9-2" }, null, -1))
          ], 64))
        : (_ctx.visualId === 'gtr-win')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[6] || (_cache[6] = _createElementVNode("path", { d: "M6.2 3.6h11.6l3.2 5.2L12 20.6 3 8.8l3.2-5.2Z" }, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("path", { d: "M3 8.8h18M8.7 8.8 12 3.6l3.3 5.2M12 20.6 8.7 8.8M12 20.6l3.3-11.8" }, null, -1))
            ], 64))
          : (_ctx.visualId === 'license')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _cache[8] || (_cache[8] = _createElementVNode("rect", {
                  x: "2.8",
                  y: "5.2",
                  width: "18.4",
                  height: "13.6",
                  rx: "2.4"
                }, null, -1)),
                _cache[9] || (_cache[9] = _createElementVNode("circle", {
                  cx: "8.6",
                  cy: "11",
                  r: "2"
                }, null, -1)),
                _cache[10] || (_cache[10] = _createElementVNode("path", { d: "M5.4 16.4c.6-1.5 1.8-2.3 3.2-2.3s2.6.8 3.2 2.3" }, null, -1)),
                _cache[11] || (_cache[11] = _createElementVNode("path", { d: "M14.8 10.4h4M14.8 13.6h4" }, null, -1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _cache[12] || (_cache[12] = _createElementVNode("path", { d: "M3.4 7.6 12 3.2l8.6 4.4v8.8L12 20.8l-8.6-4.4V7.6Z" }, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("path", { d: "m3.4 7.6 8.6 4.5 8.6-4.5M12 12.1v8.7" }, null, -1))
              ], 64))
  ], 14, _hoisted_1))
}